/* istanbul ignore file */

process.env.NODE_ENV === 'development' && import('@core/css-autoreload');

import '@core/cache-debug';
import '@core/app-banner';

import { Trace, Warn } from '@utilities/logging';
Trace(`🔧 Code version: ${process.env.IMAGE_VERSION}`);

import(/* webpackPreload: true */ './_core');

if (import.meta.webpackHot) import.meta.webpackHot.accept(Warn);
else if (module.hot) module.hot.accept(Warn);
